import React from 'react'

import styled from 'styled-components'

const WFHSection = ({
  os = 'Not specified.',
  processor = 'Not specified.',
  ram = 0,
  osVersion = 'Not specified.',
  webCamera = 'Not specified.',
  headSet = 'Not specified.',
  microphone = 'Not specified.',
  downloadSpeed = 0,
  uploadSpeed = 0,
  pingTime = 0,
  city,
  backupInfrastructure,
  showBackupInfrastructure,
}) => {
  return (
    <Container>
      <InnerContent>
      <Header>Work From Home Setup</Header>

      {/* Internet Connectivity */}
      <SectionTitle>Internet Connectivity</SectionTitle>
      <InternetBox>
        <Metric>
          <label>Upload Speed</label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={require('../../../assets/image/arrow_icon.png')}
              alt="Upload Icon"
              style={{ width: "20px", height: "20px" }}
            />
            <span className="value">
              {(uploadSpeed / 1000).toFixed(2)}
            </span>
          </div>
          <span className="unit">Mbps</span>
        </Metric>
        <Metric>
          <label>Download Speed</label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={require('../../../assets/image/arrow_icon.png')}
              alt="Download Icon"
              style={{ 
                width: "20px", 
                height: "20px",
                transform: "rotate(180deg)"
              }}
            />
            <span className="value">
              {(downloadSpeed / 1000).toFixed(2)}
            </span>
          </div>
          <span className="unit">Mbps</span>
        </Metric>
        <Metric>
          <label>Ping</label>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={require('../../../assets/image/wifi_icon.png')}
              alt="Wifi Icon"
              style={{ width: "20px", height: "20px" }}
            />
            <span className="value">{pingTime}</span>
          </div>
          <span className="unit">ms</span>
        </Metric>
      </InternetBox>

      {/* Device Specifications */}
      <SectionTitle>Device Specifications</SectionTitle>
      <Section>
  
        <Row>
          <Spec>
            <Label>Operating System</Label>
            <SpecValue>{os}</SpecValue>
          </Spec>
          <Spec>
            <Label>OS Version</Label>
            <SpecValue>{osVersion}</SpecValue>
          </Spec>
          <Spec>
            <Label>Installed RAM</Label>
            <SpecValue>{ram}</SpecValue>
          </Spec>
        </Row>
      </Section>

      {/* Peripherals */}
      <SectionTitle>Peripherals</SectionTitle>
      <Section>
        <Row>
          <Spec>
            <Label>Web Cam</Label>
            <SpecValue>{webCamera}</SpecValue>
          </Spec>
          <Spec>
            <Label>Headset</Label>
            <SpecValue>{headSet}</SpecValue>
          </Spec>
          <Spec>
            <Label>Microphone</Label>
            <SpecValue>{microphone}</SpecValue>
            <SpecValue>{city}</SpecValue>
          </Spec>
        </Row>
      </Section>

      {showBackupInfrastructure && (
        <>
          <SectionTitle>Backup Infrastructure</SectionTitle>
          <Section>
            {backupInfrastructure ? (
              <Metric>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)", // 3 per row
                    gap: "24px",
                    textAlign: "center",
                  }}
                >
                  <div>
                    <Label>OS</Label>
                    <Value>{backupInfrastructure.os}</Value>
                  </div>

                  <div>
                    <Label>OS Version</Label>
                    <Value>{backupInfrastructure.osVersion}</Value>
                  </div>

                  <div>
                    <Label>Processor</Label>
                    <Value>{backupInfrastructure.processor}</Value>
                  </div>

                  <div>
                    <Label>Display</Label>
                    <Value>{backupInfrastructure.display}</Value>
                  </div>

                  <div>
                    <Label>RAM</Label>
                    <Value>{backupInfrastructure.ram} GB</Value>
                  </div>
                  
                </div>
              </Metric>
            ) : (
              <Metric>
                <span className="value empty">No backup infrastructure</span>
              </Metric>
            )}
          </Section>
        </>
      )}
      </InnerContent>
    </Container>
  );
};

export default WFHSection;

const Container = styled.div`
  background: #0a093d;
  color: #fff;
  min-height: 50vh; 
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center; 
  align-items: center; 
`;

const InnerContent = styled.div`
  width: 100%;
  max-width: 1000px; 
  padding: 2rem;      /* spacing sa loob */
`;

const Header = styled.h2`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
`;

const Section = styled.div`
  margin-bottom: 2rem;
  border-top: 1px solid #ff3366;
  padding-top: 1rem;
`;

const SectionTitle = styled.h3`
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 1rem;
`;

const InternetBox = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  font-family: 'Inter', sans-serif;
  color: #fff;
  margin-bottom: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #ff3366;
`;

const Metric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  label {
    font-size: 0.9rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .value {
    font-size: 1.5rem;
    font-weight: 700;
  }

  .unit {
    font-size: 0.8rem;
    opacity: 0.8;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
  gap: 1rem;
`;

const Label = styled.div`
  font-size: 0.75rem;
  opacity: 0.8;
`;

const Value = styled.p`
  font-weight: 500;
  font-size: 0.85rem;
  color: #fff;
`

const Spec = styled.div``;

const SpecValue = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 0.25rem;
`;
